// AnnounceBbsView.js
// import React, {useEffect, useState, useRef} from 'react';
import { styled  } from '@mui/material/styles';
import { Box } from '@mui/system';
import {
    DialogContent, DialogActions, Button
} from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import EditIcon from '@mui/icons-material/Edit';
import CampaignIcon from '@mui/icons-material/Campaign';
import { VzmDataText, VzmInputFlex, VzmLabel } from '../../../common/VzmStyled';
import { AppStyle, AppWord } from '../../../value/AppConst';
import { useReactiveVar } from '@apollo/client';
import { userInfoRepo } from '../../../value/AppModel';
import BbsFiles from '../BbsFiles';
import DraggableViewer from '../../../common/DraggableViewer';

// background color in gradient style (light gray to white, then light gray)
const ViewContainer = styled(Box)({
    fontSize: '0.9rem', marginTop: 10, minWidth: 600
});

// show new lines in text (as is)
const TextBox = styled(Box)({
    padding: 15, borderRadius: 10,
    background: 'linear-gradient(#f0f0f0 0%, #ffffff 20%, #ffffff 80%, #f0f0f0 100%)',
    whiteSpace: 'pre-line',
    minHeight: 250, overflowY: 'auto',
    maxHeight: '40vh', boxSizing: 'border-box',
});

/**
 * 공지사항 게시판 상세 보기
 * @param {*} param0 
 * @returns 
 */
export default function AnnounceBbsView({
    open,
    item,
    onRequestEdit,
    onRequestReload,
    onClose
}) {
    const sessionInfo = useReactiveVar(userInfoRepo);

    if(!open || !item) return null;

    const canEdit = item.regUser === sessionInfo.user.userId;

    return(
        <DraggableViewer open={open} onClose={onClose} maxWidth='xl'
            startIcon={<CampaignIcon fontSize={AppWord.LARGE} />}
            title={item.title}
            fullScreen={window.innerWidth < 800}
        >
            <DialogContent>
                <ViewContainer>
                    <TextBox>{item.content}</TextBox>
                    <VzmInputFlex
                        style={{justifyContent: 'space-between'}}
                    >
                        <VzmInputFlex>
                            <VzmLabel>작성자</VzmLabel>
                            <VzmDataText>{item.writer}</VzmDataText>
                        </VzmInputFlex>
                        <VzmInputFlex>
                            <VzmLabel>최종수정</VzmLabel>
                            <VzmDataText>{item.updatedDate}</VzmDataText>
                        </VzmInputFlex>
                    </VzmInputFlex>
                    <BbsFiles
                        item={item}
                        onRequestReload={onRequestReload}
                    />
                </ViewContainer>
            </DialogContent>
            <DialogActions>
                {
                    canEdit ?
                    <Button
                        onClick={()=>{onRequestEdit(item)}}
                        variant={AppStyle.mui.contained}
                        color={AppStyle.mui.inherit}
                        sx={{width: 120, marginRight: 1}}
                        startIcon={<EditIcon />}
                    >
                        편집
                    </Button>
                    : null
                }
                <Button onClick={onClose}
                    variant={AppStyle.mui.contained}
                    color={AppStyle.mui.primary}
                    sx={{width: 120}}
                    startIcon={<DoneIcon />}
                >
                    닫기
                </Button>
            </DialogActions>
        </DraggableViewer>
    );
}